import React, { useEffect, useState } from "react";
import { Input, Modal, Select, message } from "antd";
import Button from "../../../common/Button";
import { useRaiseRequest, useRequestTypes } from "../../../hooks/useRequests";
import { queryErrorMessage } from "../helpers";
import "../AdminBatchList/style.scss";

const AdminRaiseRequestModal = ({ sku, batchId, batchNumber, onClose }) => {
  const [requestType, setRequestType] = useState();
  const [comment, setComment] = useState("");
  const skuLabel = sku?.displayName || sku?.draftSkuName || "";

  const { data: requestTypes = [], isLoading: isTypesLoading } = useRequestTypes();
  const selectedType = requestTypes.find((row) => row.key === requestType);
  const commentRequired = Boolean(selectedType?.commentRequired);

  useEffect(() => {
    if (!requestType && requestTypes[0]?.key) {
      setRequestType(requestTypes[0].key);
    }
  }, [requestType, requestTypes]);

  const { mutate: raise, isLoading } = useRaiseRequest(
    () => {
      message.success("Request raised");
      onClose();
    },
    (err) => message.error(queryErrorMessage(err) || "Could not raise request.")
  );

  const canSubmit = Boolean(requestType) && !(commentRequired && !comment.trim());

  const handleSubmit = () => {
    if (!canSubmit) return;
    raise({
      requestType,
      comment,
      requestData: {
        skuId: sku?.skuId || sku?._id,
        skuName: skuLabel,
        batchId,
        batchNumber,
      },
    });
  };

  return (
    <Modal
      title={`Raise request for ${skuLabel || "SKU"}`}
      open
      onCancel={onClose}
      footer={null}
      width="520px"
    >
      <div className="raise_request_form">
        <div className="filter_field">
          <label>Request type</label>
          <Select
            loading={isTypesLoading}
            options={requestTypes.map((row) => ({ value: row.key, label: row.name }))}
            value={requestType}
            onChange={setRequestType}
            style={{ width: "100%" }}
          />
        </div>
        <div className="filter_field">
          <label>
            Comment{commentRequired ? " *" : ""}
          </label>
          <Input.TextArea
            rows={4}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder={commentRequired ? "Required" : "Optional"}
          />
        </div>
        <div className="action_wrapper">
          <button className="cancelBtn" type="button" onClick={onClose}>
            Cancel
          </button>
          <Button
            width="140px"
            height="40px"
            text={isLoading ? "Raising..." : "Raise"}
            isDisabled={isLoading || isTypesLoading || !canSubmit}
            handleClick={handleSubmit}
          />
        </div>
      </div>
    </Modal>
  );
};

export default AdminRaiseRequestModal;
